{
	"questions_of": "Question {value} of {total}",
	"enter_answer": "Enter answer",
	"next": "Next",
	"complete": "Complete",
	"success_title": "Congratulations",
	"success_description": "You have successfully completed survey",
	"soon_redirected": "You will be soon redirected",
	"something_went_wrong":  "Something went wrong",
	"try_again": "Please try again"
}
